(function ($) {
    $.fn.onVisible = function(callback) {
        return this.each(function () {
            const $el = $(this);
            const el = this;

            // Disconnect any existing observer on this element
            if (el._onVisibleObserver instanceof MutationObserver) {
                el._onVisibleObserver.disconnect();
            }

            // If already visible, run callback immediately
            if ($el.is(':visible')) {
                callback($el);
                return;
            }

            // Create a new observer
            const observer = new MutationObserver(() => {
                if ($el.is(':visible')) {
                    observer.disconnect();
                    callback($el);
                }
            });

            observer.observe(el, {
                attributes: true,
                attributeFilter: ['style', 'class'],
                subtree: false
            });

            // Store observer reference for future cleanup
            el._onVisibleObserver = observer;
        });
    };
}(jQuery));
